import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faPenToSquare,
    faTrash,
    faCubes
} from "@fortawesome/free-solid-svg-icons";
import Swal from 'sweetalert2';

const TenantRow = ({ tenant, onEdit, onDelete }) => {

    const handleClickModify = () => {
        onEdit(tenant);
    };

    const handleClickDelete = async () => {
        Swal.fire({
            title: `¿Está seguro que desea eliminar el tenant ${tenant.codTenant}?`,
            showDenyButton: true,
            confirmButtonText: 'Sí, estoy seguro',
            confirmButtonColor: '#ff0000',
            denyButtonColor: '#3d4d87',
            denyButtonText: 'No',
        }).then((result) => {
            if (result.isConfirmed) {
                onDelete(tenant);
            }
        });
    };

    return (
        <div className="tenantRow">
            <div className="infoContainer">
                <FontAwesomeIcon icon={faCubes} className="rrIcon" id="primaryIcon" />
                <div className="infoDiv">
                    <h6>Código Tenant:</h6>
                    <label id="codTenantLabel">{tenant.codTenant}</label>
                </div>
                <div className="infoDiv">
                    <h6>Nombre:</h6>
                    <label>{tenant.name}</label>
                </div>
                <div className="infoDiv">
                    <h6>Estado:</h6>
                    <label className={tenant.enabled ? 'enabledChip' : 'disabledChip'}>
                        {tenant.enabled ? 'Activo' : 'Inactivo'}
                    </label>
                </div>
            </div>
            <div className="funcionesDiv">
                <FontAwesomeIcon icon={faPenToSquare} onClick={handleClickModify} className="rrIcon" />
                <FontAwesomeIcon icon={faTrash} className="rrIcon" onClick={handleClickDelete} />
            </div>
        </div>
    );
};

export default TenantRow;
